import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { podNameVars } from '../styles-shared';

interface StyledEditableNameProps {
    $focused?: boolean;
}

export const StyledEditableName = styled(motion.div)<StyledEditableNameProps>`
    &&& {
        ${podNameVars};

        &:hover {
            --yat_editable-text-area-bg-color: ${({ theme }) => theme.shades.white['5']};
        }

        &:active {
            --yat_editable-text-area-bg-color: ${({ theme }) => theme.shades.white['10']};
        }

        ${({ $focused }) =>
            $focused &&
            css`
                position: relative;
                z-index: 6;
            `};

        // TODO: Revisit these styles:

        // 1. Leave room for the remaining characters indicator.
        @media (min-width: 480px) and (max-width: 767px) {
            margin-right: 55px;
        }
    }
`;
